import { Storage } from './storage';

export class LocalStorage<StorageI extends Record<string, any> = any> implements Storage<StorageI> {
	private STORAGE_KEY = 'widgetStorage';

	private getAll() {
		let result: any = localStorage.getItem(this.STORAGE_KEY);

		try {
			return JSON.parse(result) || {};
		} catch {
			this.save({});
			return {};
		}
	}

	public get<Key extends keyof StorageI | undefined = undefined>(
		key?: Key
	): Promise<
		Key extends undefined ? Partial<StorageI> : Key extends keyof Partial<StorageI> ? Partial<StorageI>[Key] : never
	> {
		return this.toAsync(() => {
			const storage = this.getAll();
			return key ? storage[key] : storage;
		});
	}

	public set<Data extends Partial<StorageI>>(data: Data): Promise<boolean> {
		return this.toAsync(() => {
			const storage = this.getAll();
			this.save({ ...storage, ...data });
			return true;
		});
	}

	public remove<Key extends keyof StorageI>(key: Key): Promise<boolean> {
		return this.toAsync(() => {
			const storage = this.getAll();
			delete storage[key];
			this.save(storage);
			return true;
		});
	}

	private save(data: Record<string, any>) {
		localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
	}

	private toAsync<Fn extends () => any>(fn: Fn): Promise<ReturnType<Fn>> {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve(fn());
			}, 10);
		});
	}
}
